import CopyIcon from 'assets/images/shopping/CopyIcon';
import FlagImageByUrl from 'components/FlagImageByUrl/FlagImageByUrl';
import { IShipmentData } from 'types/orders';
import { copyClipboard } from 'utils/copyClipboard';
import { displaySuccessNotification } from 'utils/displayNudosStandardNotifications';
import { getShipmentInfoCopyText } from 'utils/getShipmentInfoCopyText';
import { IDestinationDisplay, NO_INFORMATION_LABEL } from '../useShipmentDetailDrawer';

interface IDestinationBlockProps {
  shipment: IShipmentData;
  destinationDisplay: IDestinationDisplay;
  noInformation?: string;
}

const DestinationBlock = ({
  shipment,
  destinationDisplay,
  noInformation = NO_INFORMATION_LABEL
}: IDestinationBlockProps) => {
  const { title, countryFlagUrl, countryShortName } = destinationDisplay;
  const receiverInfo = shipment.receiverInfo;

  const idDocument =
    receiverInfo?.receiverIdDocument ?? shipment.receiverIdDocument ?? noInformation;

  const phone = (() => {
    if (receiverInfo?.receiverPhoneCountryCode && receiverInfo?.receiverPhone) {
      return `${receiverInfo.receiverPhoneCountryCode} ${receiverInfo.receiverPhone}`;
    }
    if (shipment.receiverPhone) return shipment.receiverPhone;
    if (receiverInfo?.receiverPhone) return receiverInfo.receiverPhone;
    if (shipment?.userInfo?.phoneData?.phone && shipment?.userInfo?.phoneData?.phoneCode) {
      return `+${shipment.userInfo.phoneData.phoneCode} ${shipment.userInfo.phoneData.phone}`;
    }
    return noInformation;
  })();
  const address = shipment.destinationAddress ?? shipment.deliveryAddress ?? noInformation;
  const references = shipment.additionalReferences ?? 'Sin indicaciones';

  const handleCopyShipmentInfo = () => {
    displaySuccessNotification({
      customJSXMessage: <>Información de direccion copiada con éxito</>
    });

    copyClipboard({ text: getShipmentInfoCopyText(shipment) });
  };

  return (
    <>
      <div className="destinationHeader">
        <span className="destinationTitle">
          Envío {title}
          <button
            className="copyButton"
            onClick={() => handleCopyShipmentInfo()}
            aria-label="Copiar información del envío"
          >
            <CopyIcon />
          </button>
        </span>
      </div>

      <div className="receiverInfoGrid">
        <div className="infoField">
          <span className="fieldLabel">Documento de identidad</span>
          <span className="fieldValue">{idDocument}</span>
        </div>

        <div className="infoField">
          <span className="fieldLabel">Número de teléfono</span>
          <span className="fieldValue">{phone}</span>
        </div>

        <div className="infoField">
          <span className="fieldLabel">País</span>
          <span className="fieldValue countryValue">
            {countryShortName || noInformation}
            {countryFlagUrl && (
              <FlagImageByUrl url={countryFlagUrl} className="countryFlagImage" />
            )}
          </span>
        </div>

        <div className="infoField">
          <span className="fieldLabel">Ciudad</span>
          <span className="fieldValue">{shipment.city ?? noInformation}</span>
        </div>

        <div className="infoField">
          <span className="fieldLabel">Código Postal</span>
          <span className="fieldValue">{shipment.zipCode ?? noInformation}</span>
        </div>
      </div>

      <div className="addressSection">
        <div className="infoField">
          <span className="fieldLabel">Dirección</span>
          <span className="fieldValue">{address}</span>
        </div>

        <div className="infoField">
          <span className="fieldLabel">Indicaciones</span>
          <span className="fieldValue">{references}</span>
        </div>
      </div>
    </>
  );
};

export default DestinationBlock;
